import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class SessionIdService implements HttpInterceptor {
    private sessionId: string;

    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({ headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });

        if (request.body) {
            const action: string = request.body.action;
            if (this.shouldAddSessionId(action)) {
                this.sessionId = this.authService.currentAuth.session_id;
                request = request.clone({
                    body: { ...request.body, session_id: this.sessionId }
                });
            }
        }
        return next.handle(request);
    }

    private shouldAddSessionId(action: string): boolean {
        return action !== 'login' && action !== 'signup' && this.authService.isAuthenticated;
    }
}
